<template>
  <div v-if="isLoading" class="fullscreen-loading">
    <loading>Starting app...</loading>
  </div>
  <authenticate v-else-if="notLoggedIn" />
  <layout v-else />
  <alert-box />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import MainMenu from "./components/MainMenu.vue";
import { AuthState } from "./store";
import Loading from "./components/Loading.vue";
import Layout from "./views/Layout.vue";
import Authenticate from "./views/Authenticate.vue";
import AlertBox from "./components/AlertBox.vue";

@Options({
  components: {
    MainMenu,
    Loading,
    Layout,
    Authenticate,
    AlertBox,
  },
  computed: {
    ...mapState(["authState"]),
  },
})
export default class App extends Vue {
  authState!: AuthState;
  globalSelectDisable!: boolean;

  get isLoading() {
    return this.authState === AuthState.Authenticating;
  }

  get notLoggedIn() {
    return this.authState === AuthState.NotLoggedIn;
  }

  mounted() {
    this.$store.dispatch("loadAuthInfo");
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Ubuntu+Mono&display=swap");

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  font-size: 12px;
  min-width: 1024px;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
button,
input,
textarea {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.fullscreen-loading {
  height: 100vh;
}

.menu-fullscreen-loading {
  height: calc(100vh - 48px);
}

.fullscreen-loading,
.menu-fullscreen-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.select-disable {
  user-select: none;
}

.btn {
  padding: 0;
  font-size: 1em;
  padding: 2px;
  box-sizing: border-box;
  border: 1px solid #999;
  text-align: center;
  background: linear-gradient(180deg, #f0f0f0 0%, #d0d0d0 100%);
  cursor: pointer;
  &:hover {
    outline: 1px solid rgba(0, 0, 0, 0.3);
    background: linear-gradient(180deg, #d0d0d0 0%, #b0b0b0 100%);
  }
}

.btn-outline {
  border: 1px solid #444;
  color: #444;
  border-radius: 3px;
  background: transparent;
  height: 28px;
  cursor: pointer;
  margin-right: 4px;
  padding: 4px 12px;
  text-transform: uppercase;
  font-size: 0.95em;
  text-decoration: none;
  transition: color 0.15s ease, background-color 0.15s ease;
  &:hover {
    outline: 2px solid rgba(0, 0, 0, 0.3);
  }
  &:disabled {
    border-color: #999;
    color: #999;
    cursor: auto;
    &:hover {
      outline: none;
    }
  }
  &.active {
    background-color: #444;
    color: white;
  }
}

.btn-danger {
  border-color: #c44;
  color: #c00;
  &:hover {
    outline: 2px solid rgba(255, 0, 0, 0.3);
  }
}

.btn-sq {
  box-sizing: border-box;
  width: 28px;
  padding: 4px;
  overflow: hidden;
}

.btn-small {
  padding: 2px 4px;
}

input.input {
  height: 28px;
  box-sizing: border-box;
  background: #eee;
  border: 1px solid #999;
  border-radius: 3px;
  padding: 2px 6px;
  &:focus {
    outline: 2px solid #aaa;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.small {
  font-size: 0.9em;
}

.btn-group {
  button.btn-outline {
    margin: 0;
    border-radius: 0;
    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &:not(:last-child) {
      border-right: none;
    }
  }
}
</style>
